import { Navigate, Route, Routes } from "react-router-dom";
import EmailPage from "./pages/EmailPage";
import AddUserPage from "./pages/AddUserPage";
import AlertPage from "./pages/AlertPage";
import AssignRolePage from "./pages/AssignRolePage";
import AvatarPage from "./pages/AvatarPage";
import BadgesPage from "./pages/BadgesPage";
import ButtonPage from "./pages/ButtonPage";
import CalendarMainPage from "./pages/CalendarMainPage";
import CardPage from "./pages/CardPage";
import CarouselPage from "./pages/CarouselPage";
import ChatEmptyPage from "./pages/ChatEmptyPage";
import ChatMessagePage from "./pages/ChatMessagePage";
import ChatProfilePage from "./pages/ChatProfilePage";
import CodeGeneratorNewPage from "./pages/CodeGeneratorNewPage";
import CodeGeneratorPage from "./pages/CodeGeneratorPage";
import ColorsPage from "./pages/ColorsPage";
import ColumnChartPage from "./pages/ColumnChartPage";
import CompanyPage from "./pages/CompanyPage";
import CurrenciesPage from "./pages/CurrenciesPage";
import DropdownPage from "./pages/DropdownPage";
import ErrorPage from "./pages/ErrorPage";
import FaqPage from "./pages/FaqPage";
import ForgotPasswordPage from "./pages/ForgotPasswordPage";
import FormLayoutPage from "./pages/FormLayoutPage";
import FormValidationPage from "./pages/FormValidationPage";
import FormPage from "./pages/FormPage";
import GalleryPage from "./pages/GalleryPage";
import ImageGeneratorPage from "./pages/ImageGeneratorPage";
import ImageUploadPage from "./pages/ImageUploadPage";
import InvoiceAddPage from "./pages/InvoiceAddPage";
import InvoiceEditPage from "./pages/InvoiceEditPage";
import InvoiceListPage from "./pages/InvoiceListPage";
import InvoicePreviewPage from "./pages/InvoicePreviewPage";
import KanbanPage from "./pages/KanbanPage";
import LanguagePage from "./pages/LanguagePage";
import LineChartPage from "./pages/LineChartPage";
import ListPage from "./pages/ListPage";
import MarketplaceDetailsPage from "./pages/MarketplaceDetailsPage";
import MarketplacePage from "./pages/MarketplacePage";
import NotificationAlertPage from "./pages/NotificationAlertPage";
import NotificationPage from "./pages/NotificationPage";
import PaginationPage from "./pages/PaginationPage";
import PaymentGatewayPage from "./pages/PaymentGatewayPage";
import PieChartPage from "./pages/PieChartPage";
import PortfolioPage from "./pages/PortfolioPage";
import PricingPage from "./pages/PricingPage";
import ProgressPage from "./pages/ProgressPage";
import RadioPage from "./pages/RadioPage";
import RoleAccessPage from "./pages/RoleAccessPage";
import SignInPage from "./pages/SignInPage";
import SignUpPage from "./pages/SignUpPage";
import StarRatingPage from "./pages/StarRatingPage";
import StarredPage from "./pages/StarredPage";
import SwitchPage from "./pages/SwitchPage";
import TableBasicPage from "./pages/TableBasicPage";
import TableDataPage from "./pages/TableDataPage";
import TabsPage from "./pages/TabsPage";
import TagsPage from "./pages/TagsPage";
import TermsConditionPage from "./pages/TermsConditionPage";
import TextGeneratorPage from "./pages/TextGeneratorPage";
import ThemePage from "./pages/ThemePage";
import TooltipPage from "./pages/TooltipPage";
import TypographyPage from "./pages/TypographyPage";
import UsersGridPage from "./pages/UsersGridPage";
import UsersListPage from "./pages/UsersListPage";
import ViewDetailsPage from "./pages/ViewDetailsPage";
import VideoGeneratorPage from "./pages/VideoGeneratorPage";
import VideosPage from "./pages/VideosPage";
import VoiceGeneratorPage from "./pages/VoiceGeneratorPage";
import WalletPage from "./pages/WalletPage";
import WidgetsPage from "./pages/WidgetsPage";
import WizardPage from "./pages/WizardPage";
import RouteScrollToTop from "./helper/RouteScrollToTop";
import TextGeneratorNewPage from "./pages/TextGeneratorNewPage";
import GalleryGridPage from "./pages/GalleryGridPage";
import GalleryMasonryPage from "./pages/GalleryMasonryPage";
import GalleryHoverPage from "./pages/GalleryHoverPage";
import BlogPage from "./pages/BlogPage";
import BlogDetailsPage from "./pages/BlogDetailsPage";
import AddBlogPage from "./pages/AddBlogPage";
import TestimonialsPage from "./pages/TestimonialsPage";
import ComingSoonPage from "./pages/ComingSoonPage";
import AccessDeniedPage from "./pages/AccessDeniedPage";
import MaintenancePage from "./pages/MaintenancePage";
import BlankPagePage from "./pages/BlankPagePage";
import SocietyControllerRouter from "./Routing/SocietyController/Routers";
import SocietyPortalRouter from "./Routing/SocietyPortal/Routers";
import PublicBill from "./pages/Public/PublicBill";

import { PUBLIC_BILL, SOCIETY_CONTROLLER, SOCIETY_PORTAL } from "./Routing/routes";

import { ToastContainer } from "react-toastify";
import EditSocietyMangement from "./pages/SocietyController/SocietyManagement/EditSocietyMangement";
import { useEffect } from "react";
// eslint-disable-next-line no-unused-vars
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { relogin } from "./redux/actions/AuthActions/LoginAction";
import { relogin as adminRelogin } from "./redux/actions/AuthActions/AdminLoginaAction/AdminLoginAction";
import { NetworkStatusNotifier } from './components/NetworkStatusNotifier';
import webTokenStorer from "./utils/webStorer";

// Society Portal imports
import SocietyPortalDashboard from "./pages/SocietyPortal/Dashboard/Dashboard";
import SocietyPortalLogin from "./pages/SocietyPortal/Auth/Login/Login";
import SocietyPortalSignUp from "./pages/SocietyPortal/Auth/Signup/Signup";
import SocietyPortalForgotPassword from "./pages/SocietyPortal/Auth/ForgotPassword/ForgotPassword";
import SocietyProfile from "./pages/SocietyPortal/Society/SocietyProfile/SocietyProfile";
import EditSocietyProfile from "./pages/SocietyPortal/Society/SocietyProfile/EditSocietyProfile";
import Wings from "./pages/SocietyPortal/Society/WingsAndFlats/Wings";
import Flats from "./pages/SocietyPortal/Society/WingsAndFlats/Flats";
import MasterLayout from "./masterLayout/SocietyPortal/MasterLayout";
import ControllerMasterLayout from "./masterLayout/SocietyController/MasterLayout";
import OwnersPage from "./pages/SocietyPortal/Society/Members/OwnersPage";
import TenantsPage from "./pages/SocietyPortal/Society/Members/TenantsPage";
import FamilyPage from "./pages/SocietyPortal/Society/Members/FamilyPage";
import AddOwner from "./pages/SocietyPortal/Society/Members/AddOwner";
import AddTenant from "./pages/SocietyPortal/Society/Members/AddTenant";
import AddFamily from "./pages/SocietyPortal/Society/Members/AddFamily";

// Society Portal - Finance imports
import Invoices from "./pages/SocietyPortal/Finance/Invoices/Invoices";
import CreateInvoice from "./pages/SocietyPortal/Finance/Invoices/CreateInvoice";
import PrintInvoice from "./pages/SocietyPortal/Finance/Invoices/PrintInvoice";
import BulkPrintInvoices from "./pages/SocietyPortal/Finance/Invoices/BulkPrintInvoices";
import BulkCreateInvoice from "./pages/SocietyPortal/Finance/Invoices/BulkCreateInvoice";
import CreditNotes from "./pages/SocietyPortal/Finance/CreditNotes/CreditNotes";
import CreateCreditNote from "./pages/SocietyPortal/Finance/CreditNotes/CreateCreditNote";
import PrintNote from "./pages/SocietyPortal/Finance/CreditNotes/PrintNote";
import BulkPrintNotes from "./pages/SocietyPortal/Finance/CreditNotes/BulkPrintNotes";
import EditCreditNote from "./pages/SocietyPortal/Finance/CreditNotes/EditCreditNote";
import DebitNotes from "./pages/SocietyPortal/Finance/DebitNotes/DebitNotes";
import CreateDebitNote from "./pages/SocietyPortal/Finance/DebitNotes/CreateDebitNote";
import EditDebitNote from "./pages/SocietyPortal/Finance/DebitNotes/EditDebitNote";
import BulkUploadCreditDebitNotes from "./pages/SocietyPortal/Finance/CreditNotes/BulkUploadCreditDebitNotes";
import Receipts from "./pages/SocietyPortal/Finance/Receipts/Receipts";
import CreateReceipt from "./pages/SocietyPortal/Finance/Receipts/CreateReceipt";
import PrintReceipt from "./pages/SocietyPortal/Finance/Receipts/PrintReceipt";
import BulkPrintReceipts from "./pages/SocietyPortal/Finance/Receipts/BulkPrintReceipts";
import BulkUploadReceipts from "./pages/SocietyPortal/Finance/Receipts/BulkUploadReceipts";

// Society Portal - Vendor imports
import Vendors from "./pages/SocietyPortal/Vendor/Vendors";
import AddVendor from "./pages/SocietyPortal/Vendor/AddVendor";
import ViewVendor from "./pages/SocietyPortal/Vendor/ViewVendor";
import EditVendor from "./pages/SocietyPortal/Vendor/EditVendor";
import VendorBill from "./pages/SocietyPortal/Vendor/VendorBill";
import AddVendorBill from "./pages/SocietyPortal/Vendor/AddVendorBill";
import ViewVendorBill from "./pages/SocietyPortal/Vendor/ViewVendorBill";
import EditVendorBill from "./pages/SocietyPortal/Vendor/EditVendorBill";
import VendorTariff from "./pages/SocietyPortal/Vendor/VendorTariff";
import VendorPayment from "./pages/SocietyPortal/Vendor/VendorPayment";
import AddVendorPayment from "./pages/SocietyPortal/Vendor/AddVendorPayment";
import EditVendorPayment from "./pages/SocietyPortal/Vendor/EditVendorPayment";
import ViewVendorPayment from "./pages/SocietyPortal/Vendor/ViewVendorPayment";
import VendorSetting from "./pages/SocietyPortal/Vendor/VendorSetting";
import VendorSettingCategories from "./pages/SocietyPortal/Vendor/VendorSettingCategories";
import VendorSettingBilling from "./pages/SocietyPortal/Vendor/VendorSettingBilling";
import VendorSettingNotifications from "./pages/SocietyPortal/Vendor/VendorSettingNotifications";
import VendorSettingApprovals from "./pages/SocietyPortal/Vendor/VendorSettingApprovals";

// Society Portal - Invoice Setup imports
import BillingTypes from "./pages/SocietyPortal/Setup/InvoiceSetup/BillingTypes/BillingTypes";
import BillSeries from "./pages/SocietyPortal/Setup/InvoiceSetup/BillSeries/BillSeries";
import DocumentSeries from "./pages/SocietyPortal/Setup/InvoiceSetup/DocumentSeries/DocumentSeries";
import ChargeHead from "./pages/SocietyPortal/Setup/InvoiceSetup/ChargeHead/ChargeHead";
import FunctionalSetting from "./pages/SocietyPortal/Setup/InvoiceSetup/FunctionalSetting/FunctionalSetting";
import TaxRules from "./pages/SocietyPortal/Setup/InvoiceSetup/TaxRules/TaxRules";
import MeterReading from "./pages/SocietyPortal/Setup/InvoiceSetup/MeterReading/MeterReading";
import OpeningBalance from "./pages/SocietyPortal/Setup/InvoiceSetup/OpeningBalance/OpeningBalance";
import BankAccounts from "./pages/SocietyPortal/Setup/InvoiceSetup/BankAccounts/BankAccounts";

// Society Portal - Accounts imports
import Journal from "./pages/SocietyPortal/Accounts/Journal/Journal";
import AddJournal from "./pages/SocietyPortal/Accounts/Journal/AddJournal";
import EditJournal from "./pages/SocietyPortal/Accounts/Journal/EditJournal";
import BulkImportJournal from "./pages/SocietyPortal/Accounts/Journal/BulkImportJournal";
import ChartOfAccounts from "./pages/SocietyPortal/Accounts/ChartOfAccounts/ChartOfAccounts";
import Opening from "./pages/SocietyPortal/Accounts/Opening/Opening";
import Closing from "./pages/SocietyPortal/Accounts/Closing/Closing";
import MemberDaybook from "./pages/SocietyPortal/Accounts/MemberDaybook/MemberDaybook";
import FixedAssets from "./pages/SocietyPortal/Accounts/FixedAssets/FixedAssets";
import AddFixedAssets from "./pages/SocietyPortal/Accounts/FixedAssets/AddFixedAssets";
import EditFixedAssets from "./pages/SocietyPortal/Accounts/FixedAssets/EditFixedAssets";
import CashAndBank from "./pages/SocietyPortal/Accounts/CashAndBank/CashAndBank";
import BankBook from "./pages/SocietyPortal/Accounts/CashAndBank/BankBook";
import Investments from "./pages/SocietyPortal/Accounts/Investments/Investments";
import Reconciliation from "./pages/SocietyPortal/Accounts/Reconciliation/Reconciliation";
import BRSDetail from "./pages/SocietyPortal/Accounts/Reconciliation/BRSDetail";
import IncomeExpenditureReport from "./pages/SocietyPortal/AccountsReports/IncomeExpenditure/IncomeExpenditure";
import BalanceSheetReport from "./pages/SocietyPortal/AccountsReports/BalanceSheet/BalanceSheet";
import TrialBalanceReport from "./pages/SocietyPortal/AccountsReports/TrialBalance/TrialBalance";
import GroupLedgerReport from "./pages/SocietyPortal/AccountsReports/GroupLedger/GroupLedger";
import MemberLedgerReport from "./pages/SocietyPortal/Reports/MemberLedgerReport/MemberLedgerReport";
import InvoiceReport from "./pages/SocietyPortal/Reports/InvoiceReport/InvoiceReport";
import InvoiceAgingReport from "./pages/SocietyPortal/Reports/InvoiceAgingReport/InvoiceAgingReport";
import InterestReport from "./pages/SocietyPortal/Reports/InterestReport/InterestReport";
import ReceiptReport from "./pages/SocietyPortal/Reports/ReceiptReport/ReceiptReport";
import CDNoteReport from "./pages/SocietyPortal/Reports/CDNoteReport/CDNoteReport";
import GSTReport from "./pages/SocietyPortal/Reports/GSTReport/GSTReport";
import ReconciliationReport from "./pages/SocietyPortal/Reports/ReconciliationReport/ReconciliationReport";
import { installPermissionToastFilter } from "./utils/accessDenied";

function App() {
  const dispatch = useDispatch()
  // A 403 is reported by the Access Denied page the route shows; the toast the
  // saga also raises for it is dropped so it isn't said twice.
  useEffect(() => { installPermissionToastFilter(); }, [])
  useEffect(() => {
    const path = window.location.pathname;
    if (path.startsWith(SOCIETY_CONTROLLER)) {
      if (webTokenStorer.getToken2()) dispatch(adminRelogin({}))
    } else if (path.startsWith(SOCIETY_PORTAL)) {
      if (webTokenStorer.getToken()) dispatch(relogin({}))
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <>
      <NetworkStatusNotifier />
      <RouteScrollToTop />
      <Routes>
        {/* <Route path={ } element={<HomePageOne />} /> */}

        {/* society controller routes */}
        <Route path={`${SOCIETY_CONTROLLER}/*`} element={<SocietyControllerRouter />} />

        {/* society portal routes */}
        <Route path={`${SOCIETY_PORTAL}/*`} element={<SocietyPortalRouter />} />

        {/* No login: a bill opened from a shared link */}
        <Route path={PUBLIC_BILL} element={<PublicBill />} />

        {/* Root → Society Portal login (login component self-redirects to dashboard if already authenticated) */}
        <Route path={'/'} element={<SocietyPortalLogin />} />


        {/* Society Portal routes */}


        {/* normal routes */}
        {/* <Route element={<ProtectedRoute2 />}>
          <Route path={DASHBOARD} element={<Dashboard />} />
          <Route path={SETUP_RECORDS_WINGS_LIST} element={<WingsList />} />
          <Route path={SETUP_RECORDS_FLAT_LIST} element={<FlatsList />} />
          <Route exact path='/index-2' element={<HomePageTwo />} />
          <Route exact path='/index-3' element={<HomePageThree />} />
          <Route exact path='/index-4' element={<HomePageFour />} />
          <Route exact path='/index-5' element={<HomePageFive />} />
          <Route exact path='/index-6' element={<HomePageSix />} />
          <Route exact path='/index-7' element={<HomePageSeven />} />
          <Route exact path='/index-8' element={<HomePageEight />} />
          <Route exact path='/index-9' element={<HomePageNine />} />
          <Route exact path='/index-10' element={<HomePageTen />} />
          <Route exact path='/index-11' element={<HomePageEleven />} />
        </Route>
        <Route exact path='/login' element={<AdminLogin />} />
        <Route exact path={LOGIN_ADMIN} element={<AdminLogin />} />
        <Route exact path={LOGIN_ADMIN_FORGOT_PASSWORD} element={<AdminForgotPassword />} />
        <Route exact path={SIGN_UP_ADMIN} element={<AdminSignUp />} /> */}
        {/* <Route path={LOGIN_EMPLOYEE} element={<EmployeeLogin />} />
        <Route path={LOGIN_EMPLOYEE_FORGOT_PASSWORD} element={<EmployeeForgotPassword />} /> */}
        {/* <Route path={SIGN_UP_EMPLOYEE} element={<EmployeeSignUp />} /> */}


        {/* SL */}
        <Route exact path='/add-user' element={<AddUserPage />} />
        <Route exact path='/alert' element={<AlertPage />} />
        <Route exact path='/assign-role' element={<AssignRolePage />} />
        <Route exact path='/avatar' element={<AvatarPage />} />
        <Route exact path='/badges' element={<BadgesPage />} />
        <Route exact path='/button' element={<ButtonPage />} />
        <Route exact path='/calendar-main' element={<CalendarMainPage />} />
        <Route exact path='/calendar' element={<CalendarMainPage />} />
        <Route exact path='/card' element={<CardPage />} />
        <Route exact path='/carousel' element={<CarouselPage />} />
        <Route exact path='/chat-empty' element={<ChatEmptyPage />} />
        <Route exact path='/chat-message' element={<ChatMessagePage />} />
        <Route exact path='/chat-profile' element={<ChatProfilePage />} />
        <Route exact path='/code-generator' element={<CodeGeneratorPage />} />
        <Route
          exact
          path='/code-generator-new'
          element={<CodeGeneratorNewPage />}
        />
        <Route exact path='/colors' element={<ColorsPage />} />
        <Route exact path='/column-chart' element={<ColumnChartPage />} />
        <Route exact path='/company' element={<CompanyPage />} />
        <Route exact path='/currencies' element={<CurrenciesPage />} />
        <Route exact path='/dropdown' element={<DropdownPage />} />
        <Route exact path='/email' element={<EmailPage />} />
        <Route exact path='/faq' element={<FaqPage />} />
        <Route exact path='/forgot-password' element={<ForgotPasswordPage />} />
        <Route exact path='/form-layout' element={<FormLayoutPage />} />
        <Route exact path='/form-validation' element={<FormValidationPage />} />
        <Route exact path='/form' element={<FormPage />} />

        <Route exact path='/gallery' element={<GalleryPage />} />
        <Route exact path='/gallery-grid' element={<GalleryGridPage />} />
        <Route exact path='/gallery-masonry' element={<GalleryMasonryPage />} />
        <Route exact path='/gallery-hover' element={<GalleryHoverPage />} />

        <Route exact path='/blog' element={<BlogPage />} />
        <Route exact path='/blog-details' element={<BlogDetailsPage />} />
        <Route exact path='/add-blog' element={<AddBlogPage />} />

        <Route exact path='/testimonials' element={<TestimonialsPage />} />
        <Route exact path='/coming-soon' element={<ComingSoonPage />} />
        <Route exact path='/access-denied' element={<AccessDeniedPage />} />
        <Route exact path='/maintenance' element={<MaintenancePage />} />
        <Route exact path='/blank-page' element={<BlankPagePage />} />

        <Route exact path='/image-generator' element={<ImageGeneratorPage />} />
        <Route exact path='/image-upload' element={<ImageUploadPage />} />
        <Route exact path='/invoice-add' element={<InvoiceAddPage />} />
        <Route exact path='/invoice-edit' element={<InvoiceEditPage />} />
        <Route exact path='/invoice-list' element={<InvoiceListPage />} />
        <Route exact path='/invoice-preview' element={<InvoicePreviewPage />} />
        <Route exact path='/kanban' element={<KanbanPage />} />
        <Route exact path='/language' element={<LanguagePage />} />
        <Route exact path='/line-chart' element={<LineChartPage />} />
        <Route exact path='/list' element={<ListPage />} />
        <Route
          exact
          path='/marketplace-details'
          element={<MarketplaceDetailsPage />}
        />
        <Route exact path='/marketplace' element={<MarketplacePage />} />
        <Route
          exact
          path='/notification-alert'
          element={<NotificationAlertPage />}
        />
        <Route exact path='/notification' element={<NotificationPage />} />
        <Route exact path='/pagination' element={<PaginationPage />} />
        <Route exact path='/payment-gateway' element={<PaymentGatewayPage />} />
        <Route exact path='/pie-chart' element={<PieChartPage />} />
        <Route exact path='/portfolio' element={<PortfolioPage />} />
        <Route exact path='/pricing' element={<PricingPage />} />
        <Route exact path='/progress' element={<ProgressPage />} />
        <Route exact path='/radio' element={<RadioPage />} />
        <Route exact path='/role-access' element={<RoleAccessPage />} />
        <Route exact path='/sign-in' element={<SignInPage />} />
        <Route exact path='/sign-up' element={<SignUpPage />} />
        <Route exact path='/star-rating' element={<StarRatingPage />} />
        <Route exact path='/starred' element={<StarredPage />} />
        <Route exact path='/switch' element={<SwitchPage />} />
        <Route exact path='/table-basic' element={<TableBasicPage />} />
        <Route exact path='/table-data' element={<TableDataPage />} />
        <Route exact path='/tabs' element={<TabsPage />} />
        <Route exact path='/tags' element={<TagsPage />} />
        <Route exact path='/terms-condition' element={<TermsConditionPage />} />
        <Route
          exact
          path='/text-generator-new'
          element={<TextGeneratorNewPage />}
        />
        <Route exact path='/text-generator' element={<TextGeneratorPage />} />
        <Route exact path='/theme' element={<ThemePage />} />
        <Route exact path='/tooltip' element={<TooltipPage />} />
        <Route exact path='/typography' element={<TypographyPage />} />
        <Route exact path='/users-grid' element={<UsersGridPage />} />
        <Route exact path='/users-list' element={<UsersListPage />} />
        <Route exact path='/view-details' element={<ViewDetailsPage />} />
        <Route exact path='/video-generator' element={<VideoGeneratorPage />} />
        <Route exact path='/videos' element={<VideosPage />} />
        <Route exact path='/view-profile' element={<Navigate to={`${SOCIETY_CONTROLLER}/profile`} replace />} />
        <Route exact path='/voice-generator' element={<VoiceGeneratorPage />} />
        <Route exact path='/wallet' element={<WalletPage />} />
        <Route exact path='/widgets' element={<WidgetsPage />} />
        <Route exact path='/wizard' element={<WizardPage />} />

        <Route exact path='*' element={<ErrorPage />} />
      </Routes >
      <ToastContainer />
    </>
  );
}

export default App;
